module.exports = __webpack_public_path__ + "img/allottee4_7-8-2021.95a11f40.jpg";